export default __webpack_public_path__ + "static/media/topMenu_question.ce84150d.svg";